/* hey, citizen! Interactive Script */
document.addEventListener('DOMContentLoaded', () => {
  // FAQ Accordion
  const faqRows = document.querySelectorAll('.hc-faq-row');
  faqRows.forEach(row => {
    const btn = row.querySelector('.hc-faq-btn');
    if (btn) {
      btn.addEventListener('click', () => {
        const isActive = row.classList.contains('active');
        faqRows.forEach(r => r.classList.remove('active'));
        if (!isActive) {
          row.classList.add('active');
        }
      });
    }
  });

  // Bundle Selector
  const bundleCards = document.querySelectorAll('.hc-bundle-card');
  const bundleInput = document.getElementById('selected-bundle-id');
  bundleCards.forEach(card => {
    card.addEventListener('click', () => {
      bundleCards.forEach(c => c.classList.remove('selected'));
      card.classList.add('selected');
      const val = card.getAttribute('data-bundle-id');
      if (bundleInput && val) {
        bundleInput.value = val;
      }
    });
  });

  // Smooth CTA scroll to offer
  const ctaLinks = document.querySelectorAll('a[href^="#offer"]');
  ctaLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const target = document.getElementById('offer');
      if (target) {
        target.scrollIntoView({ behavior: 'smooth' });
      }
    });
  });
});
